export default {"src":"/_next/static/media/alias-to-mask-hero.ca7a0918.svg","height":154,"width":300,"blurWidth":0,"blurHeight":0};